import React from 'react';
import { Text, fontWeightEnum, textVariantsEnum } from '@/components/Text';
import { Button as CustomButton, buttonVariants } from '@/components/Button';
import { FiMoreVertical } from 'react-icons/fi';
import { getInitials } from '@/utils/utility';
import { RoleTag, ROLE_AVATAR_STYLE_MAP } from './components/RoleTag.component';
import styles from './EmployeeList.module.scss';

// Plain single-line text cell (Department, Email) — every cell must go
// through Text so its size/weight matches the rest of the row instead of
// inheriting the browser's raw default.
function PlainCell({ children }) {
  return (
    <Text variant={textVariantsEnum.Text_sm} fontWeight={fontWeightEnum.Normal}>
      {children}
    </Text>
  );
}

/**
 * Employee roster table columns — shared by the real and demo Employee List
 * containers via EmployeeList.view.jsx. Only the two bits that vary per-row
 * render (the selected department's label and the "..." actions click
 * handler) are parameterized; everything else is pure presentation.
 */
export const employeeColumnsConfig = ({
  selectedTeamLabel,
  onActionsButtonClick,
}) => [
  {
    id: 'name',
    name: 'Employee',
    sortable: true,
    sortKey: 'name',
    style: { width: '30%' },
    cellRenderer: (row) => (
      <div className={styles.employeeCell}>
        <span
          className={styles.employeeAvatar}
          style={ROLE_AVATAR_STYLE_MAP[row.role]}
        >
          {getInitials(row.name || '')}
        </span>
        <Text
          variant={textVariantsEnum.Text_sm}
          fontWeight={fontWeightEnum.Medium}
        >
          {row.name}
        </Text>
      </div>
    ),
  },
  {
    id: 'role',
    name: 'Role',
    sortable: true,
    sortKey: 'role',
    style: { width: '18%' },
    cellRenderer: (row) => <RoleTag role={row.role} />,
  },
  {
    id: 'department',
    name: 'Department',
    style: { width: '15%' },
    cellRenderer: () => <PlainCell>{selectedTeamLabel || '—'}</PlainCell>,
  },
  {
    id: 'email',
    name: 'Email',
    sortable: true,
    sortKey: 'email',
    style: { width: '30%' },
    cellRenderer: (row) => <PlainCell>{row.email}</PlainCell>,
  },
  {
    id: 'actions',
    name: 'Actions',
    style: { width: '7%' },
    cellRenderer: (row) => (
      <CustomButton
        icon={<FiMoreVertical size={14} />}
        variant={buttonVariants.outline}
        ariaLabel="Actions"
        onClick={(e) => onActionsButtonClick(e, row)}
      />
    ),
  },
];
